import papayaIcon from "@/assets/papaya-icon.png";

const imageMap: Record<string, string> = {
  "img:papaya": papayaIcon,
};

interface RecipeEmojiProps {
  emoji: string;
  className?: string;
}

const RecipeEmoji = ({ emoji, className = "text-xl" }: RecipeEmojiProps) => {
  const src = imageMap[emoji];
  if (src) {
    return <img src={src} alt="" className={`inline-block w-[1.2em] h-[1.2em] object-contain ${className}`} />;
  }
  return <span className={className}>{emoji}</span>;
};

export default RecipeEmoji;
